<template>
  <RemarkGroup
    :name="I18n.t('client_meetings.title')"
    :show-mark-as-read="false"
  >
    <template v-for="bucket in TALKING_POINT_BUCKETS" :key="bucket">
      <div
        v-if="(buckets[bucket]?.length ?? 0) > 0"
        class="tw-flex tw-flex-col tw-gap-4"
        :data-testid="`talking-points-section-${bucket}`"
      >
        <h3
          class="
            tw-text-sm tw-font-medium tw-uppercase tw-text-sf-gray-dark tw-m-0
          "
        >
          {{ I18n.t(`communication.inbox.talking_points_groups.${bucket}`) }}
        </h3>
        <TalkingPointsBucketContent :items="buckets[bucket] ?? []" />
      </div>
    </template>
  </RemarkGroup>
</template>

<script setup lang="ts">
import RemarkGroup from '@app/application/communication/screens/inbox/components/remark-group.vue'
import TalkingPointsBucketContent from '@app/application/communication/screens/inbox/components/talking-points-bucket-content.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import type { TalkingPointBucket } from '@app/application/communication/screens/inbox/store/utils'
import { TALKING_POINT_BUCKETS } from '@app/application/communication/screens/inbox/store/utils'
import type { CheckLink, Remark } from '@app/application/communication/types'

const I18n = useI18n()

interface Props {
  buckets: Partial<Record<TalkingPointBucket, (Remark | CheckLink)[]>>
}
defineProps<Props>()
</script>
